import React, { useEffect, useState, useRef } from "react";
import { Container, Dropdown, ProgressBar, Badge } from "react-bootstrap";
import "./header.css";
import { message } from "antd";
import { Logo, Profile_Icon } from "../../../assets/images";
import { useSelector, useDispatch } from "react-redux";
import { updateJobProgress, clearJob, setJob } from "../../../features/jobSlice";
import axios from "../../../axios/axios";

const Header = () => {
  const [adminDetails, setAdminDetails] = useState({});
  const dispatch = useDispatch();
  const { jobId, progress, processed, jobTotal, jobStatus, jobMessage } = useSelector((state) => state.job);
  const [showNotification, setShowNotification] = useState(false);
  const pollIntervalRef = useRef(null);

  useEffect(() => {
    const admin = localStorage.getItem("AdminData");
    if (admin) {
      setAdminDetails(JSON.parse(admin));
    }
  }, []);

  useEffect(() => {
    if (!jobId && !localStorage.getItem("jobId")) {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
      }
      return;
    } else {
      dispatch(setJob({ jobId: localStorage.getItem("jobId") }));
    }

    const getProgress = async () => {
      try {
        const response = await axios.get(`/corporate-client/get-corporate-client-status-progress/${jobId}`);
        const data = response.data.data;
        if (!data) return;

        dispatch(updateJobProgress({
          progress: data.progress || 0,
          processed: data.processed || 0,
          total: data.total || 0,
          status: data.status || '',
          message: data.message || ''
        }));

        if (data.progress == 100) {
          clearInterval(pollIntervalRef.current);
          localStorage.removeItem("jobId");
        }
      } catch (error) {
        console.error(error);
      }
    };

    getProgress();
    pollIntervalRef.current = setInterval(getProgress, 8000); /// after 8 seconds it call again 

    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
      }
    };
  }, [jobId, dispatch]);

  const logout = async () => {
    localStorage.clear();
    message.warning("You are being logged out. Please wait...");
    window.open("/", "_self");
  };
  return (
    <div className="header_partttss">
      <Container fluid>
        <div className="header_inner">
          <div className="header_logo">
            <a href="/">
              <img src={Logo} alt="TVI" className="img-fluid" width={200} />
            </a>
          </div>
          <div className="header_user d-flex align-items-center">
            {jobId && (
              <Dropdown show={showNotification} onToggle={(isOpen) => setShowNotification(isOpen)} className="mr-3">
                <Dropdown.Toggle variant="light" className="position-relative notification-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-bell" viewBox="0 0 16 16">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                  </svg>
                  {progress !== 100 && (
                    <Badge pill bg="danger" className="position-absolute" style={{ top: "-5px", right: "-5px", backgroundColor: "red" }}>
                      1
                    </Badge>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="p-3 shadow" style={{ width: "350px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0 fw-bold">Client Status Update Notification</h6>
                    {/* <button type="button" className="close" onClick={() => dispatch(clearJob())}>&times;</button> */}
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="fw-bold" style={{ color: "#333", fontSize: "14px" }}>
                      {progress === 100 ? "Processing Completed" : jobMessage || "Processing..."}
                    </span>
                    <strong>{progress}%</strong>
                  </div>
                  <ProgressBar
                    now={progress}
                    label={`${progress}%`}
                    animated={progress !== 100}
                    variant={progress === 100 ? "success" : "primary"}
                  />
                  <div className="mt-2 text-muted" style={{ fontSize: "13px" }}>
                    {processed} / {jobTotal} processed
                  </div>
                  {progress === 100 && (
                    <div className="text-success mt-2" style={{ fontWeight: 500, fontSize: "14px" }}>
                      ✓ Operation completed successfully.
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}

            <Dropdown>
              <Dropdown.Toggle
                variant="default"
                className="ud"
                id="dropdown-basic"
              >
                <div className="ud_image">
                  <img src={Profile_Icon} alt="User" width={40} height={40} />
                </div>
                <div className="ud_name">
                  <span className="udw">Hello!</span>
                  <span className="udn">{adminDetails?.name}</span>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#" onClick={logout}>
                  Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
